"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asProperAddressObj = exports.asAddress = void 0;

var _asTitleCase = require("./asTitleCase");

var _number = require("../type-checks/number");

var _string = require("../type-checks/string");

var asAddress = function asAddress(addressObj) {
  var line1 = addressObj.line1,
      line2 = addressObj.line2,
      line3 = addressObj.line3,
      state = addressObj.state,
      city = addressObj.city,
      countryCode = addressObj.countryCode,
      postalCode = addressObj.postalCode;
  var returnAddr = "";

  if ((0, _string.isStringOfLength)(line1)) {
    returnAddr = line1;
  }

  if ((0, _string.isStringOfLength)(line2)) {
    returnAddr = "".concat(returnAddr, ", ").concat(line2);
  }

  if ((0, _string.isStringOfLength)(line3)) {
    returnAddr = "".concat(returnAddr, ", ").concat(line3);
  }

  if ((0, _string.isStringOfLength)(city)) {
    returnAddr = "".concat(returnAddr, ", ").concat(city);
  }

  if ((0, _string.isStringOfLength)(state)) {
    returnAddr = "".concat(returnAddr, ", ").concat(state);
  }

  if ((0, _string.isStringOfLength)(postalCode) || (0, _number.isNumber)(postalCode)) {
    returnAddr = "".concat(returnAddr, ", ").concat(postalCode);
  }

  if ((0, _string.isStringOfLength)(countryCode)) {
    returnAddr = "".concat(returnAddr, ", ").concat(countryCode);
  }

  return returnAddr;
};

exports.asAddress = asAddress;

var asProperAddressObj = function asProperAddressObj(addressObj) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$includeCountryCo = _ref.includeCountryCode,
      includeCountryCode = _ref$includeCountryCo === void 0 ? false : _ref$includeCountryCo,
      _ref$includePostalCod = _ref.includePostalCode,
      includePostalCode = _ref$includePostalCod === void 0 ? true : _ref$includePostalCod;

  var line1 = addressObj.line1,
      line2 = addressObj.line2,
      line3 = addressObj.line3,
      stateCode = addressObj.stateCode,
      city = addressObj.city,
      countryCode = addressObj.countryCode,
      postalCode = addressObj.postalCode;
  var l1 = null;
  var l2 = null;
  var l3 = null;
  var cspc = null;

  try {
    (0, _string.isStringOfLength)(line1) && (l1 = (0, _asTitleCase.asTitleCase)(line1));
  } catch (e) {
    console.log("Could not format Address Line 1", e);
  }

  try {
    (0, _string.isStringOfLength)(line2) && (l2 = (0, _asTitleCase.asTitleCase)(line2));
  } catch (e) {
    console.log("Could not format Address Line 2", e);
  }

  try {
    (0, _string.isStringOfLength)(line3) && (l3 = (0, _asTitleCase.asTitleCase)(line3));
  } catch (e) {
    console.log("Could not format Address Line 3", e);
  }

  try {
    if ((0, _string.isStringOfLength)(city) && (0, _string.isStringOfLength)(stateCode)) {
      cspc = "".concat((0, _asTitleCase.asTitleCase)(city), ", ").concat(stateCode.toUpperCase());
      includePostalCode && (0, _string.isStringOfLength)(postalCode) && (cspc = "".concat(cspc, " ").concat((0, _asTitleCase.asTitleCase)(postalCode)));
      includeCountryCode && (0, _string.isStringOfLength)(countryCode) && (cspc = "".concat(cspc, " ").concat(countryCode.toUpperCase()));
    }
  } catch (e) {
    console.log("Could not format Address City/State/Zip/Country", e);
  }

  return {
    line1: l1,
    line2: l2,
    line3: l3,
    cityStateZip: cspc
  };
};

exports.asProperAddressObj = asProperAddressObj;